module.exports = __webpack_public_path__ + "img/loader.7202eadb.gif";